import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { useNotaServicoService } from "../../context/NotaServicoContext";

export const ReportHeader = () => {
  const { cachedNotes, filters } = useNotaServicoService();

  const { period } = cachedNotes;

  return (
    <Grid item xs>
      <Typography variant="h4">Relatório de Nota Fiscal de Serviço</Typography>

      <Typography variant="subtitle2">
        Período da busca:{" "}
        {moment(period?.startDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}{" "}
        até{" "}
        {moment(period?.endDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}
      </Typography>
    </Grid>
  );
};
